const data = [
  { key: 'resume-description-user-anonymous', name: "Área do Credor > Resumo de Casos (Usuário deslogado)" },
  { key: 'create-user-event-anonymous', name: "Fomulário Habilitações/Divergências (Usuário deslogado)" },
  { key: 'create-user-event-logged', name: "Fomulário Habilitações/Divergências (Usuário logado)" },
  { key: 'user-event-anonymous', name: "Habilitações/Divergências (Usuário deslogado)" },
  { key: 'user-event-logged', name: "Habilitações/Divergências (Usuário logado)" },
  { key: 'contact-description', name: "Contato (Conteúdo)" },
  { key: 'faq-description', name: "Dúvidas (Introdução)" },
  { key: 'documents-template-description', name: "Modelos de Documentos (Introdução)" },
  { key: 'main-documents-description', name: "Principais Documentos (Introdução)" },
  { key: 'monthly-reports-description', name: "Relatórios Mensais (Introdução)" },
  { key: 'documents-center-description', name: "Central de Documentos (Introdução)" },
  { key: 'creditor-list-description', name: "Lista de Credores (Introdução)" },
  { key: 'official-analysis-description', name: "Análise de Ofício (Introdução)" },
  { key: 'objection-request-description', name: "Revisão de Crédito (Introdução)" },
  { key: 'help-request-description', name: "Ajuda (Introdução)" },
  { key: 'plan-adherence-description', name: "Adesão ao Plano (Introdução)" },
  { key: 'plan-adherence-content', name: "Adesão ao Plano (Conteúdo)" },
  { key: 'lawyer-creditor-add-description', name: "Procurador Adicionar Novos Credores (Introdução)" },
  { key: 'certificate-claim-description', name: "Certidão de Habilitação de Crédito (Introdução)" },
];

export default [...data];
